import Lookup from './lookup.js';

export default class Region extends Lookup
{
    
}
